import { useDrop } from 'react-dnd';
import { ROW_ITEM_DRAG_TYPE } from '../../../dataTable/components/Row';
export var useChipsDragAndDrop = function (editorBag, chipReferenceTypes) {
    var componentHelper = editorBag[0], chipHelper = editorBag[3];
    var handleDrop = function (item) {
        var _a, _b, _c;
        if (!componentHelper.editModeActive || chipReferenceTypes === undefined) {
            return;
        }
        if ((item === null || item === void 0 ? void 0 : item.rowItem) !== undefined && chipReferenceTypes.includes(item.rowItem.objectType)) {
            var chipReference = {
                id: (_a = item === null || item === void 0 ? void 0 : item.rowItem) === null || _a === void 0 ? void 0 : _a.id,
                objectType: (_b = item === null || item === void 0 ? void 0 : item.rowItem) === null || _b === void 0 ? void 0 : _b.objectType,
                name: (_c = item === null || item === void 0 ? void 0 : item.rowItem) === null || _c === void 0 ? void 0 : _c.name,
            };
            chipHelper.addChip(chipReference);
        }
    };
    var _a = useDrop({
        accept: ROW_ITEM_DRAG_TYPE,
        drop: handleDrop,
        collect: function (monitor) { return ({
            hovered: monitor.isOver(),
        }); }
    }), dropRef = _a[1];
    // Return null reference if no Chip type allowed, to prevent HTML5 'accept drop' styles
    var chipsDropReference = !!chipReferenceTypes ? dropRef : null;
    return {
        chipsDropReference: chipsDropReference,
    };
};
//# sourceMappingURL=useChipsDragAndDrop.js.map